<template>
	<v-card>
		<v-card-title>
			<h2>Historia poprawek</h2>
		</v-card-title>
		<v-card-text>
			<AgencyCompareVersionsDialog v-if="history.length > 0" :status="project.agencyProjectStatus"
				:contest-id="project.contestId" :last-version="history.length + 1"/>
			<b>Nazwa projektu:</b> {{project.title}}<br/>
			<b>Nr projektu:</b> {{project.agencyProjectCode}}<br/>
			<b>Placówka:</b> {{project.agency}}<br/>
			<b>Autor:</b> {{project.author}}
		</v-card-text>

		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:items="history">
			<template slot="items" slot-scope="props">
				<tr style="height: 64px">
					<td>{{ props.item.correctionDate }}</td>
					<td>{{ props.item.correctionCause }}</td>
					<td>{{ props.item.detailedCorrectionCause }}</td>
					<td>
						<v-btn @click="viewVersion(props.item.version)">
							Podgląd
						</v-btn>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import AgencyCompareVersionsDialog from "./compareComponents/AgencyCompareVersionsDialog";

	export default {
		name: "AgencyProjectChangesHistory",
		components: {AgencyCompareVersionsDialog},
		data () {
			return {
				lastVersion: null,
				project: {
					id: '',
					agencyProjectCode: '',
					agencyProjectStatus: '',
					title: '',
					agency: '',
					author: '',
					contestId: ''
				},
				tableHeaders: [
					{text: "Data", sortable: false, width: "180px"},
					{text: "Powód", sortable: false, width: "260px"},
					{text: "Opis", sortable: false},
					{text: "Podgląd stanu przed poprawką", sortable: false},
				],
				history: []
			};
		},

		methods: {
			refresh () {
				this.loadData();
			},

			viewVersion (version) {
				this.$router.openInNewTab("/view/agency-contest/".concat(this.project.contestId).concat("/project/")
					.concat(this.project.agencyId).concat("/").concat(this.$route.params.projectId).concat("/").concat(version));
			},

			loadData () {
				AgencyProject.getBasicData(this, this.$route.params.projectId, success => {
					this.project = success;
				});
				AgencyProject.getCorrectionHistory(this, this.$route.params.projectId, success => {
					success.shift();
					this.history = success;
					if (this.history.length > 0) {
						this.lastVersion = this.history[this.history - 1];
					}
				});
			}
		},

		created () {
			this.loadData();
		}
	};
</script>

<style scoped>

</style>